<template>
    <div class="layout">
        <Layout>
            <Top/>
            <Content class="content">
                <div class="loginWrapper">
                    <div class="loginDivWapper">
                        <img class="yellow" :src="loginImgUrl.yellowImg"/>
                        <div class="loginDiv" v-if="showLoginDiv">
                            <p class="title">
                                {{lang('loginScanText1',language)}}<a href="https://joyreader.wawayaya.com"
                                                                           target="_blank">WaWaYaYa</a>APP
                                <br>
                                {{lang('loginScanText3',language)}}
                            </p>
                            <img class="blue" :src="loginImgUrl.blueImg"/>
                            <img class="purple" :src="loginImgUrl.purpleImg"/>
                            <img class="green" :src="loginImgUrl.greenImg"/>
                            <vue-qr :logoSrc="loginImgUrl.wawayaya" :text='qrCodeText' :size="250"
                                    :style="{marginTop:'-20px'}" :logoMargin="5"></vue-qr>
                            <div class="qrCodeShelter" v-if="showQrCodeShelter" @click="refreshQrCode()">
                                <p class="qrCodeExpireText">{{lang('qrCodeExpireText',language)}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="scanSuccessDiv" v-if="showScanSuccessDiv">
                        <p class="title">
                            {{showText}}
                        </p>
                        <img class="blueSuccess" :src="loginImgUrl.blueImg"/>
                        <img class="purpleSuccess" :src="loginImgUrl.purpleImg"/>
                        <img class="greenSuccess" :src="loginImgUrl.greenImg"/>
                        <img class="scanSuccess" :src="loginImgUrl.scanSuccess"/>
                    </div>
                    <p class="copyright">Copyright ©  WaWaYaYa. All rights reserved. 京ICP备09087741号</p>
                </div>
            </Content>
        </Layout>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import {lang} from "@/utils/language.js";
    import Top from "../components/Top.vue"
    import config from '@/utils/config.js';
    import vueQr from 'vue-qr';

    export default {
        name: 'Login',
        components: {
            Top,
            vueQr,
        },
        store,
        data() {
            return {
                lang: lang,
                stateLang: '',
                loginImgUrl: {
                    yellowImg: require('../assets/yellow.png'),
                    greenImg: require('../assets/green.png'),
                    purpleImg: require('../assets/purple.png'),
                    blueImg: require('../assets/blue.png'),
                    wawayaya: require('../assets/48.png'),
                    scanSuccess:require('../assets/scanSuccess.png')
                },
                token: '',
                qrCodeText: '',
                showQrCodeShelter:false,
                retCode:'',
                showLoginDiv:true,
                showScanSuccessDiv:false,
                showText:'',
                screenWidth:0,
            }
        },
        mounted() {
            this.$nextTick(function () {
                store.commit('removeUserInfo');
                store.commit('removeScope');
                store.commit('removeIsTip');
                store.commit('removeMaxWidth');
                store.commit('removeHideModule');
                this.getToken();
            })
        },
        methods: {
            getToken() {
                let that = this;
                that.$http.get(config.netBasePath + '/open/acct/login/token').then(function (res) {
                    var body = res.body
                    if (body.retCode === 1) {
                        var retMap = body.retMap;
                        that.token = retMap.loginToken;
                        that.qrCodeText = config.weexScanLoginPath + "&token=" + that.token;
                    } else {
                        that.$Message.error(this.lang('systemError', that.language));
                    }
                }, function (res) {
                    that.$Message.error('Network request error!');
                });
            },

            getAccessToken() {
                setInterval(() => {
                    let that = this;
                    that.$http.get(config.netBasePath + '/open/acct/login/accessToken?loginToken='+that.token).then(function (res) {
                        var body = res.body;
                        console.log(body);
                        switch (body.retCode) {
                            case 1005:
                                that.showScanSuccessDiv = false;
                                that.showLoginDiv = true;
                                that.showQrCodeShelter = true;
                                break;
                            case 1:
                                var retMap = body.retMap;
                                var user = {};
                                user.userId = retMap.userId;
                                user.accessToken = retMap.accessToken;
                                user.userName = retMap.userName;
                                user.adminRole = retMap.userRole;
                                user.isSvip = retMap.isSvip;
                                console.log(user);
                                store.commit("setUserInfo",user);
                                store.commit("setIsTip",false);
                                store.commit("setMaxWidth",1080);
                                store.commit("setHideModule",[]);
                                that.$router.push('/single/Home');
                               /* if(retMap.amdinRole >=0){
                                    var user = {};
                                    user.userId = retMap.userId;
                                    user.accessToken = retMap.accessToken;
                                    user.userName = retMap.userName;
                                    user.adminRole = retMap.amdinRole;
                                    store.commit("setUserInfo",user)
                                    that.$router.push('/single/Home');
                                }else{
                                    that.showText = that.lang('loginScanText7',that.language)
                                    that.showLoginDiv = false;
                                    that.showScanSuccessDiv = true;
                                }*/
                                break;
                            case 1002:
                                that.showText = that.lang('loginScanText5',that.language)
                                that.showLoginDiv = false;
                                that.showScanSuccessDiv = true;
                                break;
                        }
                    }, function (res) {
                        that.$Message.error('Network request error!');
                    });
                },1000)
            },
            refreshQrCode(){
                this.getToken();
                this.showQrCodeShelter = false;
            }
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
        },
        watch: {
            stateLang: function () {

            },
            token: function () {
                this.getAccessToken();
            },

        }
    }


</script>

<style scoped>
    .content {
        height: 990px;
        background-image: url(../assets/bg.png);
        background-size: cover;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .loginWrapper {
        max-width: 1080px;
        height: 810px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 150px;
        width: 100%;
        align-items: center;
    }
    .loginDivWapper{
        float: right;
        width: 500.8px;
        height: 600.1px;
    }
    .loginDiv {
        position: relative;
        left: 60px;
        width: 387.8px;
        height: 459.1px;
        background: #FFFFFF;
        border-radius: 25px;
    }
    .yellow {
        position: relative;
        left: -200px;
        top: 380px;
        width: 66.6px;
        height: 66.6px;
    }
    .copyright {
        position: relative;
        top: 700px;
        left: 25%;
        color: aliceblue;
    }
    .scanSuccessDiv {
        position: relative;
        left: 692.2px;
        top: -66.6px;
        width: 387.8px;
        height: 459.1px;
        background: #FFFFFF;
        border-radius: 25px;
    }
    .scanSuccess{

    }
    .title {
        position: relative;
        left: 0px;
        top: 60px;
        font-size: 20px;
    }
    .qrCodeShelter {
        position: relative;
        left: 80px;
        top: -245px;
        background-color: black;
        opacity:0.8;
        height: 230px;
        width: 230px;
    }
    .qrCodeExpireText{
        position: relative;
        top: 115px;
        font-size: 18px;
        color: aliceblue;
    }
    .title a {
        color: #1E90FF;
        margin-left: 10px;
        margin-right: 10px;
    }
    .blue {
        position: relative;
        left: 215px;
        top: -110px;
        width: 93.6px;
        height: 93.6px;
    }
    .purple {
        position: relative;
        left: 200px;
        top: -80px;
        width: 37.8px;
        height: 37.8px;
    }
    .green {
        position: relative;
        left: -150px;
        top: 360px;
        width: 100.4px;
        height: 91.4px;
    }
    .blueSuccess {
        position: relative;
        left: 215px;
        top: -80px;
        width: 93.6px;
        height: 93.6px;
    }
    .purpleSuccess {
        position: relative;
        left: 200px;
        top: -80px;
        width: 37.8px;
        height: 37.8px;
    }
    .greenSuccess {
        position: relative;
        left: -150px;
        top: 385px;
        width: 100.4px;
        height: 91.4px;
    }


</style>
